export default function ImpactAnalysisGraphDirective() {
  return {
    template: require('./impact-analysis-graph.html'),
    scope: {
      process: '=',
    },
    controller: 'ImpactAnalysisGraphController',
    controllerAs: 'impactAnalysisGraphVM',
    bindToController: true,
    replace: true,
  };
}
